export default __webpack_public_path__ + "static/media/320x320.5c4df4e0.jpg";